/**
 * Pending attachments, sitting above the composer.
 *
 * Two shapes on purpose: an image is shown as a thumbnail, because what
 * identifies a screenshot is what's in it, not the filename the OS gave it
 * ("Captura de tela 2026-08-06 às 14.32.11.png" tells nobody anything). Every
 * other file is a pill with its name, because for a PDF or a log the name *is*
 * the identity.
 *
 * Failed uploads stay in the tray, marked. Dropping them silently would let
 * someone send the question believing the file went with it.
 */

function RemoveButton({ onClick, label, className }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={className}
    >
      <svg viewBox="0 0 12 12" aria-hidden="true" className="h-2.5 w-2.5">
        <path
          d="M3 3l6 6M9 3l-6 6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}

function FileGlyph() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" className="h-3.5 w-3.5 flex-none">
      <path
        d="M9 1.5H4.5A1.5 1.5 0 003 3v10a1.5 1.5 0 001.5 1.5h7A1.5 1.5 0 0013 13V5.5L9 1.5zM9 1.5V5a.5.5 0 00.5.5H13"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function AttachmentTray({ attachments, onRemove }) {
  if (!attachments.length) return null;

  return (
    <ul className="m-0 flex list-none flex-wrap gap-2 p-0">
      {attachments.map((attachment) => {
        const failed = attachment.status === "error";
        const uploading = attachment.status === "uploading";

        if (attachment.isImage && attachment.previewUrl) {
          return (
            <li key={attachment.id} className="relative">
              <img
                src={attachment.previewUrl}
                alt={attachment.name}
                className={`h-14 w-14 rounded-[10px] border object-cover transition-opacity ${
                  uploading ? "opacity-50" : "opacity-100"
                } ${
                  failed
                    ? "border-[#ff5a4d]"
                    : "border-black/10 dark:border-white/[.16]"
                }`}
              />
              <RemoveButton
                onClick={() => onRemove(attachment.id)}
                label={`Remover ${attachment.name}`}
                className="absolute -right-1.5 -top-1.5 grid h-[18px] w-[18px] place-items-center rounded-full border border-black/10 bg-white text-[#15161f] shadow-sm transition-colors hover:bg-[#f2f2f5] dark:border-white/20 dark:bg-[#1a1a22] dark:text-white dark:hover:bg-[#25252f]"
              />
            </li>
          );
        }

        return (
          <li key={attachment.id}>
            <span
              className={`inline-flex h-[30px] max-w-[220px] items-center gap-1.5 rounded-lg border px-2.5 text-[12.5px] font-medium transition-opacity ${
                uploading ? "opacity-60" : "opacity-100"
              } ${
                failed
                  ? "border-[#ff5a4d]/50 text-[#c0392b] dark:text-[#ff8c80]"
                  : "border-black/10 bg-black/[.03] text-[#15161f] dark:border-white/[.16] dark:bg-white/[.06] dark:text-white"
              }`}
            >
              <FileGlyph />
              <span className="truncate">{attachment.name}</span>
              {failed && <span className="flex-none text-[10.5px]">falhou</span>}
              <RemoveButton
                onClick={() => onRemove(attachment.id)}
                label={`Remover ${attachment.name}`}
                className="ml-0.5 flex-none opacity-50 transition-opacity hover:opacity-100"
              />
            </span>
          </li>
        );
      })}
    </ul>
  );
}
